// Restoran Ekranı (masa planı ve adisyon) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.restaurantScreen';

export const salesRestaurantScreenGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Restoran Ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Masa planından masayı açar, siparişi girer, mutfağa gönderir ve ödemeyi alıp masayı kapatırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Üst çubuk: kilit, tam ekran, Menü'),
    list: t(`${G}.regions.list`, 'Masa grupları'),
    form: t(`${G}.regions.form`, 'Masalar ve adisyon'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Şifrenizle giriş yapın'),
      text: t(`${G}.s1.text`, 'Ekran kilitliyken garson veya kasiyer şifrenizi girip "GİRİŞ"e basın. Adınız üst çubukta görünür. Hangi düğmeleri kullanabileceğiniz size verilen yetkilere bağlıdır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Masadan ayrılırken kilit düğmesiyle ("Ekranı Kilitle") ekranı kilitleyin; tekrar açmak için şifre gerekir.'),
        t(`${G}.s1.tip2`, 'Ayarlarda otomatik kilit açıksa, bir süre işlem yapılmayınca ekran kendiliğinden kilitlenir.'),
        t(`${G}.s1.tip3`, 'Tam ekran düğmesi veya F11 tuşu tam ekrana geçer / çıkar.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Grubu seçin, masa rengini okuyun'),
      text: t(`${G}.s2.text`, 'Soldaki "Masa Grupları" listesinden bir grup seçin ya da "Tümü" ile bütün masaları görün. Küçük ekranda gruplar, üst çubuktaki filtre düğmesiyle açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Mavi: boş masa. Yeşil: açık masa (siparişi var). Sarı: adisyonu yazdırılmış masa.'),
        t(`${G}.s2.tip2`, 'Mor: Pavo cihazına ödeme gönderilmiş ya da Pavo\'dan ödenmiş, kasiyer onayı bekleyen masa.'),
        t(`${G}.s2.tip3`, 'Masa kartındaki SS:DD süresi masanın ne kadardır açık olduğunu gösterir ("Masa Süresi" ayarı açıksa).'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Masayı açın, siparişi girin'),
      text: t(`${G}.s3.text`, 'Masaya dokunun; sipariş ekranı açılır. Ürünlere dokunarak sepete ekleyin. Sepette bir satır seçip "Sil", "Azalt", "Arttır" ile miktarı düzeltin; "Açıklama" ile ürüne not ekleyin (ör. az pişmiş).'),
      tips: [
        t(`${G}.s3.tip1`, 'Mutfağa yazdırılmış bir ürünü silmek, yazdırılmamış ürünü silmekten ayrı bir yetki ister.'),
        t(`${G}.s3.tip2`, 'Adisyon yazdırıldıktan sonra ürün eklemek için "Adisyon Sonrası Ürün Ekleme" yetkisi gerekir.'),
        t(`${G}.s3.tip3`, '"Geçmiş" düğmesi o masada kimin ne yaptığını (ürün ekleme, silme, aktarma) gösterir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Mutfağa gönderin, adisyon yazdırın'),
      text: t(`${G}.s4.text`, '"Mutfağa Yazdır" yalnız henüz mutfağa gönderilmemiş ürünleri gönderir; onay sorulur. "Adisyon Yazdır" müşteriye verilecek adisyon fişini basar ve masa sarıya döner.'),
      tips: [
        t(`${G}.s4.tip1`, 'Mutfağa veya adisyon yazdırdıktan sonra birkaç saniyelik geri sayımla masa planına dönülür. Masada kalmak için geri sayıma dokunun.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s5.title`, '5. Masa Aktar, Ürün Aktar, Sepet Böl'),
      text: t(`${G}.s5.text`, '"Masa Aktar" adisyonun tamamını başka bir masaya taşır; hedef masa doluysa iki masa birleştirilir. "Ürün Aktar" yalnız seçtiğiniz ürünleri başka masaya taşır. "Sepet Böl" hesabı iki sepete ayırıp her birini ayrı ödemenizi sağlar.'),
      tips: [
        t(`${G}.s5.tip1`, '"Masa Aktar" ve "Ürün Aktar" için masa aktarma yetkisi gerekir; sepet boşken pasiftir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s6.title`, '6. Ödemeyi alın, masayı kapatın'),
      text: t(`${G}.s6.text`, 'Nakit, POS, "Açık Hesap" veya "Diğer Ödeme" düğmesiyle ödemeyi alın; birden fazla yöntemle ödenecekse "Parçalı Ödeme"yi kullanın. Ödeme tamamlanınca masa kapanır ve boş (mavi) görünür.'),
      tips: [
        t(`${G}.s6.tip1`, '"İndirim" düğmesi yalnız indirim yetkisi olan kullanıcıda açıktır.'),
        t(`${G}.s6.tip2`, '"Adisyon İptal" önce onay, sonra iptal nedeni ister; masa ödeme alınmadan kapanır ve Restoran Raporlarında "Adisyon İptalleri" sekmesinde görünür.'),
        t(`${G}.s6.tip3`, 'Ödeme ve masa kapatma düğmeleri garsona bu yetki verilmediyse görünmez.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s7.title`, '7. Menü: masa düzeni, gün sonu, çıkış'),
      text: t(`${G}.s7.text`, '"Menü" düğmesinde "Masa Düzeni Ayarları" yönetici şifresiyle açılır: masaları sürükleyip yerleştirin, köşelerden boyutlandırın; "Yazıcı Ayarları", "Yazı Boyutu", "Masa Süresi (dk)" ve "Adisyonda İlk Açan Garson" da buradadır. "Kaydet" ile saklayın, "Sıfırla" ile varsayılan dizilime dönün.'),
      tips: [
        t(`${G}.s7.tip1`, 'Yetkili kasiyer "Gün Sonu" ile bu ekranın şubesine ait gün sonu raporunu yazdırabilir.'),
        t(`${G}.s7.tip2`, '"Çıkış Yap" oturumu kapatır. Üst çubuktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
